export default __webpack_public_path__ + "static/media/Previous2.0d859095.svg";